module.exports = __webpack_public_path__ + "img/organization.dcb6dd14.svg";